<div class="g-0">
    <div class="row">
        <div class="col-md">
            <div class="box-wrapper box-info">
                <div class="box-content-header">
                    <div class="row p-1">
                        <div class="col">
                            <div class="d-flex justify-content-between align-items-center gap-2">
                                <mat-card-title>
                                    <i class="fa-solid fa-file"></i>
                                    <span>Documente Indoc</span>
                                </mat-card-title>
                                <div class="d-flex align-items-center gap-2">
                                    <small *ngIf="beneficiar.latest_indoc_search_log.created_at" class="text-white">
                                        <i class="fa-solid fa-clock"></i>
                                        <!-- Accesat la: {{ beneficiar.latest_indoc_search_log.created_at
                                        | date: 'dd.MM.yyyy HH:mm' : "ro" }} -->
                                        Accesat de {{ beneficiar.latest_indoc_search_log.user_name }}
                                        la: {{ beneficiar.latest_indoc_search_log.created_at
                                        | date: 'dd.MM.yyyy HH:mm' : "ro" }}
                                    </small>
                                    <button class="btn btn-sm btn-success" title="Căutare" (click)="searchIndocDocs()">
                                        <i class="fa-solid fa-magnifying-glass"></i>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="box-content-body">
                    <div *ngIf="!searchedIndocDocs" class="p-2 text-center">
                        <strong><i>Apăsați butonul de căutare pentru a găsi documentele din indoc ale
                                beneficiarului</i></strong>
                    </div>
                    <div *ngIf="searchedIndocDocs && !indocDocs.length" class="p-2 text-center">
                        <strong><i>Lipsă documente Indoc</i></strong>
                    </div>
                    <div class="p-2" [style.display]="searchedIndocDocs && indocDocs.length ? 'block' : 'none'">
                        <table datatable [dtOptions]="dtOptions" class="row-border hover w-100"></table>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>